import Vuex from 'vuex'
import * as getters from './getters'
import * as actions from './actions'
import mutations from './mutations'

const state = {
    filters: {},
    models: [],
    searchEnded: false,
    favorites: {},
    applicationFavorites: {},
    application: null,
    proposals: [],
    proposal: null,
    favoritesIds: {},
    applicationId: false,
    proposalId: false,
    list: 'talents',
    project: 'default',
    overlay: false,
    confirmDeleteFavorite: true,
    showConfirmDeleteFavorite: false,
    deleteFavoriteId: 0,
    forceHidePreview: false,
    forceReloadFavorites: false
}

const store = new Vuex.Store({
    state,
    getters,
    actions,
    mutations,
})

export default store


